<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        CSV出力
      </template>

      <template v-slot:content>
        <v-row>
          <v-col cols="6">
            <div class="wrapper">
              <v-menu
                ref="startMenu"
                v-model="startMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="startDateText"
                    label="問題確定日-開始-"
                    prepend-icon="mdi-calendar"
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  no-title
                />
              </v-menu>
              <v-menu
                ref="endMenu"
                v-model="endMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="endDateText"
                    label="問題確定日-終了-"
                    prepend-icon="mdi-calendar"
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  no-title
                />
              </v-menu>
              <v-btn
                small
                color="#4a81aa"
                :dark="!!startDate && !!endDate"
                :disabled="!startDate || !endDate"
                @click="downloadCsv"
              >CSV出力</v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
    </v-base-card>
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'

export default {
  components: {
    VBaseCard,
  },
  data () {
    return {
      startDate: null,
      startMenu: false,
      endDate: null,
      endMenu: false,
    }
  },

  computed: {
    startDateText: {
      get() {
        return this.formatDate(this.startDate)
      },
      set() {
        this.startDate = null
      }
    },
    endDateText: {
      get() {
        return this.formatDate(this.endDate)
      },
      set() {
        this.endDate = null
      }
    },
  },

  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${year}/${month}/${day}`
    },
    async downloadCsv() {
      this.$app.$refs.loading.open({message: 'CSV出力中です。少々お待ちください。'})
      const startDate = this.formatDate(this.startDate)
      const endDate = this.formatDate(this.endDate)
      const res = await this.$axios(`/api/v1/admin/requests.csv?start_date=${startDate}&end_date=${endDate}`, {responseType: 'blob'})
      const blob = new Blob([res.data], { type: res.data.type })
      //レスポンスヘッダからファイル名を取得
      const contentDisposition = res.headers['content-disposition']
      const fileName = this.getFileName(contentDisposition)
      saveAs(blob, fileName)
      this.$app.$refs.loading.close()
    },
    getFileName(contentDisposition){
      let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2,
                                                    contentDisposition.length
                                                )
      //デコードするとスペースが"+"になるのでスペースへ置換
      fileName = decodeURI(fileName).replace(/\+/g, ' ')
      return fileName
    },
  }
}
</script>

<style lang="stylus" scoped>

.wrapper
  display: flex
  justify-content: space-between
  align-items: center
  gap: 20px

</style>
